/*
 * @Descripttion: 
 * @Author: 
 * @Date: 2019-12-28 10:17:13
 * @LastEditors: 
 * @LastEditTime: 2019-12-28 10:42:28
 */
module.exports = {
    BASE_URL: "http://admin.kxgwy.com"
};
